<template>
  <div>
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="appid">
        <el-input v-model="form.appid"></el-input>
      </el-form-item>
      <el-form-item label="secret">
        <el-input v-model="form.secret" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form:{}
    }
  },
  created: function() {
    console.log("MiniPro created");
  },
};
 
</script>

<style scoped>

.el-form{
  margin-top: 60px;
}
</style>